import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserGenericComponent } from '../../../user-generic.component';
import { FormsService } from '../../../../shared/forms.service';
import { UserService } from '../../../shared/user.service';
import { UserFormService } from '../../../shared/user-form.service';
import { ConsigneeRequest } from '@builtbybros/al-model';

@Component({
  selector: 'app-consignee-form',
  templateUrl: './consignee-form.component.html',
  styleUrls: ['./consignee-form.component.scss', '../../../shared/invalid-form.scss'],
  providers: [UserFormService]
})
export class ConsigneeFormComponent extends UserGenericComponent {

  consigneeForm: FormGroup;
  @Input() userRole;

  msg = {
    'codPattern': 'El código debe contener 10 dígitos',
    'codLength': 'Código muy largo',
    'companyNameRequired': 'Debe especificar el nombre de la compañia',
    'companyNameLength': 'Nombre de compañia muy largo',
    'rutRequired': 'Debe especificar el RUT',
    'rutLength': 'RUT muy largo',
    'companyAddressRequired': 'Debe especificar la dirección de la compañia',
    'companyAddressLength': 'Nombre de la compañia muy largo',
  };

  constructor(private fb: FormBuilder,
              private formsService: FormsService,
              private userService: UserService
  ) {
    super(formsService);
    this.createFormGroup();
  }

  public createFormGroup() {
    this.consigneeForm = this.fb.group({
      'companyName': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'rut': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(12)
        ])
      ],
      'companyAddress': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'cod': [
        null,
        Validators.pattern(/^[0-9]{10}$/),
      ]
    });
  }

  compareUserRole(role: number): boolean {
    return (role === 3);
  }

  public getFormGroup(): FormGroup {
    return this.consigneeForm;
  }

  getForm(): FormGroup {
    return this.consigneeForm;
  }

  submitForm(userInfo: any, id?: number) {
    let upsert;
    if (id) {
      const consignee = new ConsigneeRequest.Update();
      consignee.parse(this.consigneeForm.value);
      consignee.parse(userInfo);
      consignee.id = id;
      upsert = this.userService.updateConsignee(id, consignee);
    } else {
      const consignee = new ConsigneeRequest.Create();
      consignee.parse(this.consigneeForm.value);
      consignee.parse(userInfo);
      upsert = this.userService.createConsignee(consignee);
    }
    return upsert;
  }

}



// WEBPACK FOOTER //
// ./src/app/user/consignee/shared/consignee-form/consignee-form.component.ts